import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchCharts } from './chartsAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchChartsDataWithFilters = createAsyncThunk(
  'charts/fetchChartsDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchCharts({ filter, options }); // Pass filters to the API
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const chartsrSlice = createSlice({
  name: 'charts',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchChartsDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchChartsDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchChartsDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectChartsData = (state) => state.charts.data;
export const selectChartsStatus = (state) => state.charts.status;
export const selectChartsError = (state) => state.charts.error;

export default chartsrSlice.reducer;
